import { render, staticRenderFns } from "./w-packages.vue?vue&type=template&id=8b422d6a"
import script from "./w-packages.vue?vue&type=script&lang=js"
export * from "./w-packages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports